import notification from '../../notification';

export const showSystemErrorNotification = (message: string) => {
  notification.error({
    header: 'Oops!',
    content: message,
  });
};
